import React, { ComponentPropsWithoutRef } from 'react';
import { CardMedia } from '@rbx/ui';
import { resolveStaticSrc } from '../utils/staticLinkUtils';

type MarkdownCardMediaProps = ComponentPropsWithoutRef<typeof CardMedia>;

export default function MarkdownCardMedia({ image, src, ...otherProps }: MarkdownCardMediaProps) {
  const resolvedImage = resolveStaticSrc(image);
  const resolvedSrc = resolveStaticSrc(src);
  return <CardMedia {...otherProps} image={resolvedImage} src={resolvedSrc} />;
}
